import { cloneDeep } from 'lodash';
import productPurchaseOrderTodoType from './productPurchaseOrderTodo.type';

const initialState = {
  purchaseOrderTodos: [],
  totalCount: 0,
  loading: false,
  error: null,
  currentRequestId: null,
  filterValues: {
    searchText: '',
    supplierIds: [],
    colourwayIds: [],
    statuses: [],
    pageIndex: 1,
    pageSize: 20,
    selectedLicensor: [],
    selectedLicense: [],
    selectedLikeness: [],
  },
};

const productPurchaseOrderTodoReducer = (state = initialState, action) => {
  switch (action.type) {
    case productPurchaseOrderTodoType.FETCH_PURCHASE_ORDER_TODOS_LIST: {
      if (
        action.payload.requestId &&
        state.currentRequestId &&
        Number(action.payload.requestId) < Number(state.currentRequestId)
      ) {
        return state;
      }

      const { data, totalCount, append } = action.payload;

      return {
        ...state,
        purchaseOrderTodos: append ? [...state.purchaseOrderTodos, ...data] : data,
        totalCount: totalCount || 0,
        loading: false,
        error: null,
        currentRequestId: action.payload.requestId || state.currentRequestId,
      };
    }

    case productPurchaseOrderTodoType.UPDATE_PURCHASE_ORDER_TODO_ACTUAL_FIELDS: {
      const { orderId, updates } = action.payload;
      const { orderDetailsId, ...updateFields } = updates;

      const updatedTodos = state.purchaseOrderTodos.map((todo) => {
        if (todo._id === orderId) {
          const preservedState = {
            isExpanded: todo.isExpanded,
            expandAll: todo.expandAll,
            selectedIds: todo.selectedIds,
            isSelectAll: todo.isSelectAll,
          };
          if (orderDetailsId) {
            const firstOrderDetailId = todo.orderDetails?.[0]?._id?.toString();
            const orderDetailsIdStr = orderDetailsId.toString();

            if (firstOrderDetailId === orderDetailsIdStr) {
              return {
                ...todo,
                ...preservedState,
                ...updateFields,
                orderDetails:
                  todo.orderDetails?.map((od, index) => {
                    if (index === 0) {
                      return { ...od, ...updateFields };
                    }
                    return od;
                  }) || todo.orderDetails,
              };
            }

            if (Array.isArray(todo.expandData) && todo.expandData.length > 0) {
              return {
                ...todo,
                ...preservedState,
                expandData: todo.expandData.map((expandRow) => {
                  const detail = expandRow?.orderDetails?.[0] || {};
                  const expandDetailId = detail?._id?.toString() || expandRow?.orderDetailsId?.toString();
                  if (expandDetailId === orderDetailsIdStr) {
                    return {
                      ...expandRow,
                      ...updateFields,
                      orderDetails:
                        expandRow.orderDetails?.map((od) => {
                          if (od._id?.toString() === orderDetailsIdStr) {
                            return { ...od, ...updateFields };
                          }
                          return od;
                        }) || expandRow.orderDetails,
                    };
                  }
                  return expandRow;
                }),
              };
            }
          }
          return {
            ...todo,
            ...preservedState,
            ...updateFields,
          };
        }
        return todo;
      });

      return {
        ...state,
        purchaseOrderTodos: updatedTodos,
      };
    }

    case productPurchaseOrderTodoType.DELETE_PURCHASE_ORDER_TODO: {
      const { todoId } = action.payload;

      const updatedTodos = state.purchaseOrderTodos.filter((todo) => todo._id !== todoId);

      return {
        ...state,
        purchaseOrderTodos: updatedTodos,
        totalCount: Math.max(0, state.totalCount - 1),
      };
    }

    case productPurchaseOrderTodoType.BULK_DELETE_PURCHASE_ORDER_TODOS: {
      const { todoIds } = action.payload;

      const updatedTodos = state.purchaseOrderTodos.filter((todo) => !todoIds.includes(todo._id));

      return {
        ...state,
        purchaseOrderTodos: updatedTodos,
        totalCount: Math.max(0, state.totalCount - todoIds.length),
      };
    }

    case productPurchaseOrderTodoType.SET_FILTER_VALUES: {
      return {
        ...state,
        filterValues: {
          ...state.filterValues,
          ...action.payload,
        },
      };
    }

    case productPurchaseOrderTodoType.SET_LOADING: {
      return {
        ...state,
        loading: action.payload,
      };
    }

    case productPurchaseOrderTodoType.SET_ERROR: {
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    }

    case productPurchaseOrderTodoType.CLEAR_REDUCER: {
      return cloneDeep(initialState);
    }

    default:
      return state;
  }
};

export default productPurchaseOrderTodoReducer;
